var ModalType;
(function (ModalType) {
    ModalType["DEFAULT"] = "default";
    ModalType["DIALOG"] = "dialog";
    ModalType["FULLSCREEN"] = "fullscreen";
})(ModalType || (ModalType = {}));
export default ModalType;
//# sourceMappingURL=modal-type.js.map